import { useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { CSVLink } from "react-csv";


const IncomingData = [
  {
    td1: "INV-3066",
    td2: "Electronics",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "In stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },
  {
    td1: "INV-4266",
    td2: "Fashion",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "Out of stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Grocery",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "In stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Lifestyle",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "In stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Electronics",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "In stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Electronics",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "Out of stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "Electronics",
    td3: "Usha fan",
    td4: "01.01.2022",
    td5: "1799",
    td6: "In stock",
    td7: "10",
    td8: "VIEW DETAILS",
  },
];

const InventoryTable2 = () => {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.td6 === 'In stock'
      } 
      else if (e.target.value === '2') {
        return x.td6 === 'Out of stock'
      }
    }));
  };

  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.td2 === 'Fashion'
      } 
      else if (e.target.value === '2') {
        return x.td2 === 'Electronics'
      }
      else if (e.target.value === '3') {
        return x.td2 === 'Grocery'
      }
      else if (e.target.value === '4')  {
        return (x.td2 !== 'Grocery' && x.td2 !== 'Electronics' && x.td2 !== 'Fashion')

      }
    }));
    };

  return (
    <div id="OMS-main-content">
      <div className="order-list-box" >
        <div className="table_heading">
          <h4>PRODUCT IN-OUT</h4>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
        <div id="click-data">
          <p>Recent</p>
          
          
        </div>
        <div className="order-list-input-box">
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by invoice ID, category"
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.td1.match(val.target.value) || x.td2.match(val.target.value)
                  )
                );
                setFiltr1("");
                setFiltr2("");
              }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr1}
                onChange={handleFilter1}
            >
              <option value="" selected>
              Order Status
              </option>
              <option value="1">In stock</option>
              <option value="2">Out of stock</option>
            </select>
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr2}
                onChange={handleFilter2}
            >
              <option selected>Category</option>
              <option value="1">Fashion</option>
              <option value="2">Electronics</option>
              <option value="3">Grocery</option>
              <option value="4">other</option>
            </select>
            <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
          </div>
        </div>
        <table style={{ textAlign: "center" }}>
          <tr>
            <th>Product ID</th>
            <th>Category</th>
            <th>Item</th>
            <th>Added On</th>
            <th>Amount</th>
            <th id='center'>Order Status</th>
            <th>Status</th>
            <th>Details</th>
          </tr>
          {count.length > 0
            ? count.map((val) => {
                return (
                  <tr style={{lineHeight:"2rem"}}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td>{val.td4}</td>
                    <td>{val.td5}</td>
                    <td className="col-status"
                      id={
                        val.td6 === "In stock"
                          ? "col-green"
                          : val.td6 === "Out of stock"
                          ? "col-red"
                          : ""
                      }>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td className="view-details">{val.td8}</td>
                    <td>{val.td9}</td>
                  </tr>
                );
              })
            : IncomingData.map((val) => {
                return (
                  <tr style={{ lineHeight: "2rem" }}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td className="">
                      {val.td4}
                    </td>
                    <td>{val.td5}</td>
                    <td className="col-status"
                      id={
                        val.td6 === "In stock"
                          ? "col-green"
                          : val.td6 === "Out of stock"
                          ? "col-red"
                          : ""
                      }>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td className="view-details">{val.td8}</td>
                    <td>{val.td9}</td>
                  </tr>
                );
              })}
        </table>
      </div>
    </div>
  );
};

export default InventoryTable2;
